import Axios from "axios";
import {
  API_LIST_TASKS,
  API_LIST_TASKS_BY_CATEGORY,
  API_LIST_CATEGORIES,
  API_LIST_STATUS_BY_CATEGORY,
  API_LIST_STATUS,
  API_INFO_DISPATCH,
  API_LIST_WILAYA,
  API_AFFECT_TASK,
  API_LIST_COMPANIES,
  API_DISPATCH_TASK,
  API_TASK_NEXT_STATUS,
  API_SAVE_STATUS_TASK,
  API_LIST_STATUS_BY_TYPE,
  API_STATS_TASK,
  API_DOWNLOAD_REPORT,
  API_TASKS_DETAILS,
  API_LIST_PAGED_TASKS,
} from "./ServiceAPI";
import ServiceGetInstanceHTTP from "./ServiceGetInstanceHTTP";

class ServiceTasks {
  getLists(category) {
    if (category == "" || category === undefined) {
      console.log(ServiceGetInstanceHTTP.getAxios().get(API_LIST_TASKS));
      return ServiceGetInstanceHTTP.getAxios().get(API_LIST_TASKS);
    } else {
      console.log(
        ServiceGetInstanceHTTP.getAxios().get(
          API_LIST_TASKS_BY_CATEGORY + category
        )
      );
      return ServiceGetInstanceHTTP.getAxios().get(
        API_LIST_TASKS_BY_CATEGORY + category
      );
    }
  }

  getPagedLists(paramList) {
    return Axios.get(API_LIST_PAGED_TASKS, paramList);
  }

  getListCategories() {
    return ServiceGetInstanceHTTP.getAxios().get(API_LIST_CATEGORIES);
  }

  getListCompanies() {
    return ServiceGetInstanceHTTP.getAxios().get(API_LIST_COMPANIES);
  }

  affectTask(company) {
    return ServiceGetInstanceHTTP.getAxios().post(API_AFFECT_TASK, company);
  }

  dispatchTask(credentials) {
    return ServiceGetInstanceHTTP.getAxios().post(
      API_DISPATCH_TASK,
      credentials
    );
  }

  detailsTask(id) {
    return ServiceGetInstanceHTTP.getAxios().get(API_TASKS_DETAILS + id);
  }

  getListsStatus(category) {
    if (category == "" || category === undefined) {
      return ServiceGetInstanceHTTP.getAxios().get(API_LIST_STATUS);
    } else {
      return ServiceGetInstanceHTTP.getAxios().get(
        API_LIST_STATUS_BY_CATEGORY + category
      );
    }
  }

  getListsStatusByType(type) {
    return ServiceGetInstanceHTTP.getAxios().get(
      API_LIST_STATUS_BY_TYPE + type
    );
  }

  getNextStatus(status) {
    return ServiceGetInstanceHTTP.getAxios().get(API_TASK_NEXT_STATUS + status);
  }

  updateStatus(credentials) {
    return ServiceGetInstanceHTTP.getAxios().patch(
      API_SAVE_STATUS_TASK,
      credentials
    );
  }

  getInfoDispatch() {
    return ServiceGetInstanceHTTP.getAxios().get(API_INFO_DISPATCH);
  }

  getListWilaya() {
    return ServiceGetInstanceHTTP.getAxios().get(API_LIST_WILAYA);
  }

  getStatsTask() {
    return ServiceGetInstanceHTTP.getAxios().get(API_STATS_TASK);
  }

  downloadReportAction(taskId) {
    return ServiceGetInstanceHTTP.getAxiosToDownload().get(
      API_DOWNLOAD_REPORT + taskId
    );
  }
}

export default new ServiceTasks();
